import React from 'react';
import { UserGuideOverview } from './UserGuideOverview';
import { UserGuideAppNotes } from './UserGuideAppNotes';
import { UserGuideAppCards } from './UserGuideAppCards';

export const UserGuideContent: React.FC = () => {
    return (
        <main className="flex-1 ml-72 p-8 space-y-12">
            <UserGuideOverview />
            <UserGuideAppNotes />
            <UserGuideAppCards />
        </main>
    );
};
